export enum GuestState {
  UNCONTACTED = "UNCONTACTED",
  CONTACTED = "CONTACTED",
  ACCEPTED = "ACCEPTED",
  DECLINED = "DECLINED",
  WAITLISTED = "WAITLISTED",
}
